<template>
  <div class="product-list">
    <div class="glassesList" :style="{ marginBottom: top ? '0' : '70px' }">
      <!-- {{ $route.params.glassesList }} -->
      <div v-if="cover" class="recommend" @click="bannerPage(coverCode)">
        <div v-if="bannerLoading" class="banner-placeholder"></div>
        <img v-show="!bannerLoading && !bannerError" :src="cover" alt="banner" @load="onBannerLoad" @error="onBannerError" />
      </div>
      <h1 class="type-title">
        <span class="type-title__line"></span>
        <span class="type-title__text">{{ typeName }}</span>
        <span class="type-title__line"></span>
      </h1>
      <Lfilter ref="filter" :key="$route.params.type" :length="listConfig.count" @filterData="filterData" />
      <Lgoods id="list" ref="list" :key="$route.params.type" :loading="loading" :option="listConfig" :list="goodsList" @page="changePage" />
      <!-- <div class="shopList"></div> -->
      <LgoTop v-if="$vuetify.breakpoint.smAndDown" />
    </div>
  </div>
</template>

<script>
import { typeName } from '@/assets/utils/renderData'
import { generateHead, buildFullUrl } from '@/assets/utils/seo'
import { searchPath } from '@/assets/utils/auth'
import Lfilter from '@/components/Lfilter/index.vue'
import Lgoods from '@/components/Lgoods/index.vue'
import LgoTop from '@/components/LgoTop/index.vue'
export default {
  name: 'productList',
  key() {
    return this.$route.params.type + (this.$route.query.search || '')
  },
  components: {
    Lfilter,
    Lgoods,
    LgoTop
  },
  validate({ params, query }) {
    // throw new Error('Under Construction!')
    return searchPath(params.type)
  },
  /**
   * asyncData 接收route路径变动
   * 1 页脚导航
   * 2 nav导航
   * 3 page变更
   * 4 筛选条件变更
   * router对筛选条件 filter数据进行解码
   * 将params+query条件整合为 config
   * 将 filter合并至config
   * 形成最后查询条件
   * (sort) 可能出现先存在params  筛选操作下存在于filter
   * 经由Object.assign 实际以后手filter为最终数据
   */
  async asyncData({ route, $api, error, app }) {
    const query = route.query
    const params = route.params
    const config = {
      limit: 18,
      type: params.type,
      sort: params.sort ? params.sort : 'Default',
      page: query.page ? query.page : 1
    }
    if (query.search) {
      config.search = query.search
    }
    // filter转码
    let filter
    if (query.filter && query.filter !== 'all') {
      filter = decodeURI(query.filter)
      try {
        filter = JSON.parse(filter)
        Object.assign(config, filter)
      } catch (error) {
        filter = 'all'
      }
    }
    const { data: goodsList, count, cover, coverCode } = await $api.product.getGoodsList(config)

    const hasCover = cover && cover.length > 0
    return {
      goodsList,
      cover: hasCover ? cover : undefined,
      coverCode,
      listConfig: {
        filter,
        page: config.page,
        limit: config.limit,
        search: config.search,
        count
      },
      loading: false
    }
  },
  data() {
    return {
      cover: undefined,
      coverCode: undefined,
      bannerLoading: false,
      bannerError: false,
      // 商品列表
      goodsList: [],
      // 商品参数
      listConfig: {
        count: null,
        limit: 18
      },
      loading: false
    }
  },
  head() {
    const canonicalUrl = buildFullUrl(this.$route.path)
    return generateHead(this.$route.params.type, { canonicalUrl, url: canonicalUrl }, this.$route.path)
  },

  computed: {
    top: function () {
      if (this.$route.name === 'search') {
        return ''
      }
      return 'none'
    },
    typeName() {
      return typeName(this.$route.params.type) || this.$route.query.search
    }
  },

  watchQuery: true,
  created() {
    if (this.cover) {
      this.bannerLoading = true
    }
    this._filterReady = false
  },
  mounted() {
    this.recordPage('list')
  },
  methods: {
    // 记录进入页面
    recordPage(type) {
      this.$api.system.track_log({ type })
    },
    // banner 图片加载完成
    onBannerLoad() {
      this.bannerLoading = false
    },
    // banner 图片加载失败
    onBannerError() {
      this.bannerLoading = false
      this.bannerError = true
    },
    // 点图跳转
    bannerPage(code) {
      if (code) {
        this.$router.push({
          name: 'details-code',
          params: { code }
        })
      }
    },
    // 移动页面到商品列表顶部（跳过banner）
    getViewScroll() {
      const recommend = document.querySelector('.recommend')
      if (recommend && document.documentElement.scrollTop < recommend.clientHeight) {
        return
      }
      const target = document.getElementById('list')
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },
    // 切换页码 整合现有筛选条件 携带跳转更改路径 触发asyncData
    getListPage(page = 1) {
      this.getViewScroll()
      const query = {
        page,
        search: this.listConfig.search
      }
      if (this.listConfig.filter && this.listConfig.filter !== 'all') {
        const filter = encodeURI(JSON.stringify(this.listConfig.filter))
        query.filter = filter
      }
      this.$router.push({
        name: 'search-type',
        params: this.$route.params,
        query
      })
    },
    // 翻页
    changePage(val) {
      this.getListPage(val)
    },
    // 筛选条件
    filterData(val) {
      const selected = val.selected
      const list = {}
      // 组合
      for (const key in selected) {
        if (selected[key].length) {
          list[key] = []
          for (let index = 0; index < selected[key].length; index++) {
            const item = selected[key][index]
            if (key === 'size') {
              list[key].push(item.name)
            } else {
              list[key].push(item.id)
            }
          }
        }
      }
      // size选项处理 (Custom)
      if (val.selected.size && val.selected.size[0].name === 'Custom') {
        if (JSON.stringify(val.widthVal) !== '{}') {
          list.frame_width_min = val.widthVal.FrameValue[0]
          list.frame_width_max = val.widthVal.FrameValue[1]
          list.temple_min = val.widthVal.TempleValue[0]
          list.temple_max = val.widthVal.TempleValue[1]
          list.lens_width_min = val.widthVal.lensW[0]
          list.lens_width_max = val.widthVal.lensW[1]
          list.lens_height_min = val.widthVal.lensH[0]
          list.lens_height_max = val.widthVal.lensH[1]
          list.bridge_min = val.widthVal.bridgeW[0]
          list.bridge_max = val.widthVal.bridgeW[1]
        }
      }
      list.sort = val.sort
      const query = this.$route.query
      this.listConfig = {
        page: 1,
        limit: 18,
        count: null,
        filter: list
      }
      if (query.search) {
        this.listConfig.search = query.search
      }
      // 跳过 Lfilter 初始化（非用户操作）触发的空筛选事件
      if (!this._filterReady) {
        this._filterReady = true
        const hasFilter = Object.keys(list).some(k => k !== 'sort')
        if (!hasFilter && list.sort === (this.$route.params.sort || 'Default')) {
          return
        }
      }
      this.getListPage()
    }
  }
}
</script>

<style lang="scss" scoped>
.recommend {
  position: relative;
  img {
    width: 100%;
    display: block;
  }
  cursor: pointer;
}
.type-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin: 36px 0 16px;
  padding: 0 24px;

  &__text {
    font-size: 28px;
    font-weight: 700;
    color: #1a1a1a;
    text-transform: uppercase;
    letter-spacing: 4px;
    white-space: nowrap;
    position: relative;
    padding-bottom: 10px;

    &::after {
      content: '';
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 0;
      height: 3px;
      border-radius: 2px;
      background: linear-gradient(90deg, #03a9f4, #ff0202, #3067f2);
      background-size: 200% 100%;
      animation: title-underline 0.6s cubic-bezier(0.25, 0.8, 0.25, 1.2) 0.2s forwards, title-gradient 3s linear infinite;
    }
  }

  &__line {
    display: block;
    height: 1px;
    flex: 1;
    max-width: 80px;
    background: linear-gradient(90deg, transparent, #d0d0d0, transparent);
    transform: scaleX(0);
    animation: line-expand 0.6s ease-out 0.1s forwards;
  }
}

@keyframes title-underline {
  from {
    width: 0;
  }
  to {
    width: 60%;
  }
}

@keyframes title-gradient {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 200% 50%;
  }
}

@keyframes line-expand {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
.banner-placeholder {
  width: 100%;
  padding-top: 25%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%);
  background-size: 400% 100%;
  animation: banner-shimmer 1.4s ease infinite;
}
@keyframes banner-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
#list {
  &::v-deep.body-page {
    scroll-margin: 145px;
    padding-top: 20px;
  }
}
</style>
